import { useAsyncExecutor } from "async-executor-hook";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import { getAttributeList } from "../../common/searchParams.utils";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import UsersManagementSearch from "./UsersManagementSearch";
import UsersManagementTableNew from "./UsersManagementTableNew";

const UsersManagementResource = (props) => {
  const { userCompanyMe, userProfileMe, userInfo } = props;
  const params$ = useQueryParams$().pipe(
    map((params: any) => {
      return {
        ...params,
        user_info: params.user_info || "",
        profiles: getAttributeList(params.profiles),
      };
    })
  );

  const loadUsers = useAsyncExecutor(
    async (params) => {
      return await networkBackendRequest(`/users/`, HTTP_METHODS.GET, {
        ...params,
      }).then((response) => response.json());
    },
    {
      source$: params$.pipe(
        map((params) => ({
          ...params,
          order: "descending",
          page: params.page ? params.page : 1,
          page_size: ITEMS_PER_PAGE,
        }))
      ),
      onSuccess: () => {},
      onError: () => {},
    }
  );

  return (
    <div>
      <UsersManagementSearch
        params$={params$}
        userCompanyMe={userCompanyMe}
        userProfileMe={userProfileMe}
        userInfo={userInfo}
        loadUsers={loadUsers}
      />
      <UsersManagementTableNew
        params$={params$}
        userCompanyMe={userCompanyMe}
        userProfileMe={userProfileMe}
        userInfo={userInfo}
        loadUsers={loadUsers}
      />
    </div>
  );
};

export default UsersManagementResource;
